import { BrowserRouter, Route, Routes } from "react-router-dom"
import { AnalyticsPageViewTracker } from "./components/AnalyticsPageViewTracker.js"
import { ErrorBoundary } from "./components/ErrorBoundary.js"
import { GlobalErrorOverlay } from "./components/GlobalErrorOverlay.js"
import { LoginErrorBanner } from "./components/LoginErrorBanner.js"
import { ScrollToTop } from "./components/ScrollToTop.js"
import { AdminPage } from "./features/admin/AdminPage.js"
import { MarginInventoryPage } from "./features/admin/MarginInventoryPage.js"
import { AuthRouteFallback } from "./features/auth/AuthRouteFallback.js"
import { BackdoorLoginPage } from "./features/auth/BackdoorLoginPage.js"
import { BenefitListPage } from "./features/benefit/BenefitListPage.js"
import { CompanyPage } from "./features/company/CompanyPage.js"
import { DisclaimerPage } from "./features/legal/DisclaimerPage.js"
import { ListDetailPage } from "./features/lists/ListDetailPage.js"
import { ListsPage } from "./features/lists/ListsPage.js"
import { useLoginSuccessTracking } from "./lib/auth.js"

function LoginSuccessTracker() {
  useLoginSuccessTracking()
  return null
}

export function App() {
  return (
    <ErrorBoundary>
      <GlobalErrorOverlay />
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsPageViewTracker />
        <LoginSuccessTracker />
        <LoginErrorBanner />
        <Routes>
          <Route path="/auth/*" element={<AuthRouteFallback />} />
          <Route path="/" element={<BenefitListPage />} />
          <Route path="/companies/:id" element={<CompanyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/margin-inventory" element={<MarginInventoryPage />} />
          <Route path="/login/backdoor" element={<BackdoorLoginPage />} />
          <Route path="/lists" element={<ListsPage />} />
          <Route path="/lists/:id" element={<ListDetailPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
